export default __webpack_public_path__ + "static/media/kemenko.7ca7756b.svg";